import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import rootReducer from "./reducers/rootReducer"


export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: true}), //.concat(promise)
    devTools: process.env?.NODE_ENV !== 'production',
})


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
    >;
